var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditwhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38242 2.48315H7.84909C4.01576 2.48315 2.48242 4.01649 2.48242 7.84982L2.48242 12.4498C2.48242 16.2832 4.01576 17.8165 7.84909 17.8165H12.4491C16.2824 17.8165 17.8158 16.2832 17.8158 12.4498V10.9165",
    stroke: "white",
    strokeWidth: 1.725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2467 3.26514L7.20532 9.30647C6.97532 9.53647 6.74532 9.9888 6.69932 10.3185L6.36965 12.6261C6.24699 13.4618 6.83732 14.0445 7.67299 13.9295L9.98065 13.5998C10.3027 13.5538 10.755 13.3238 10.9927 13.0938L17.034 7.05247C18.0767 6.0098 18.5673 4.79847 17.034 3.26514C15.5007 1.7318 14.2893 2.22247 13.2467 3.26514Z",
    stroke: "white",
    strokeWidth: 1.725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3789 4.13159C12.8926 5.96393 14.3262 7.39759 16.1662 7.91893",
    stroke: "white",
    strokeWidth: 1.725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditwhite);
export default __webpack_public_path__ + "static/media/editwhite.1b57c911fcb34fb5f960aa8fbef6d8ab.svg";
export { ForwardRef as ReactComponent };